<template>
  <div class="bg-white p-4 rounded-lg shadow-lg">
    <!-- Header with enumType details and type menu -->
    <div class="flex justify-between items-center mb-2">
      <div>
        <h3>{{ enumType.name }}</h3>
        <p class="text-sm text-gray-600">ID: {{ enumType._id }}</p>
        <p class="text-sm text-gray-600">Description: {{ enumType.description || 'N/A' }}</p>
        <p class="text-xs text-gray-400">
          Created: {{ formatDate(enumType.createdAt) }} | Updated:
          {{ formatDate(enumType.updatedAt) }}
        </p>
      </div>
      <!-- Enum type actions menu -->
      <Button icon="pi pi-ellipsis-v" class="p-button-rounded" @click="toggleTypeMenu($event)" />
      <Menu :model="typeMenuItems" popup ref="typeMenu" />
    </div>

    <!-- Enum values list -->
    <div>
      <ul>
        <li
          v-for="val in enumType.values"
          :key="val.value"
          class="flex justify-between items-center border-b border-gray-200 py-2"
        >
          <div>
            <p class="text-sm font-medium">{{ val.value }}</p>
            <p class="text-xs text-gray-500">
              Active: {{ val.isActive ? 'Yes' : 'No' }}, Created: {{ formatDate(val.createdAt) }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button';
import Menu from 'primevue/menu';

export default {
  name: 'EnumType',
  components: { Button, Menu },
  props: {
    enumType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedValue: null,
    };
  },
  computed: {
    // Menu for the enumType type (edit and delete)
    typeMenuItems() {
      return [
        {
          label: 'Edit Enum',
          icon: 'pi pi-pencil',
          command: () => this.$emit('edit-enum', this.enumType),
        },
        {
          label: 'Delete Enum',
          icon: 'pi pi-trash',
          command: () => this.$emit('delete-enum', this.enumType),
        },
      ];
    },
    // Menu for each enumType value (edit and delete)
    valueMenuItems() {
      return [
        {
          label: 'Edit Value',
          icon: 'pi pi-pencil',
          command: () => this.$emit('edit-value', { enum: this.enumType, value: this.selectedValue }),
        },
        {
          label: 'Delete Value',
          icon: 'pi pi-trash',
          command: () => this.$emit('delete-value', { enum: this.enumType, value: this.selectedValue }),
        },
      ];
    },
  },
  methods: {
    toggleTypeMenu(event) {
      this.$refs.typeMenu.toggle(event);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString();
    },
  },
};
</script>

<style scoped>
/* Optional component-specific styling */
</style>
